import React from "react";
import "./Inner_Header.css";
import { IoChevronBack } from "react-icons/io5";
import { FaUserCircle } from "react-icons/fa";
import { MdNotificationsOff } from "react-icons/md";
import { Link, useNavigate } from "react-router-dom";

function Inner_Header() {
  const navigate = useNavigate();
  return (
    <section className="Inner_Header">
      <div className="header-left">
        <IoChevronBack onClick={() => navigate(-1)} />
      </div>

      <div className="header-center">
        <Link to="/home">
          <img
            src="/assets/images/logo/money_king.png"
            alt="Money King"
            className="logo_icon"
          />
        </Link>
      </div>

      <div className="header-right">
        <Link to={"/self-service-center"}>
          <img
            src="/assets/images/icons/support.png"
            alt="header icon"
            className="header_icon"
          />
        </Link>
        <Link to={"/home"}>
          <img
            src="/assets/images/icons/disk.png"
            alt="header icon"
            className="header_icon"
          />
        </Link>
      </div>
    </section>
  );
}

export default Inner_Header;
